import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
      <p style={{ textAlign: "justify" }}>
  Hi Everyone, I am <span className="purple">Joyonta Chakraborty</span> from 
  <span className="purple"> Sylhet, Bangladesh.</span>
  <br />
 
  I specialize in building modern and user-friendly <b className="purple">mobile applications</b> using technologies like 
  <b className="purple"> Flutter, Kotlin, and Java</b>. I am passionate about creating apps that are not only functional but also visually appealing and optimized for performance.
  <br />
  <br />
  I enjoy solving real-world problems through clean and efficient code, and I continuously strive to learn and implement the latest trends in mobile development.
  <br />
  <br />
  Apart from coding, some other activities that I love to do!
</p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Soumyajit</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
